import { v4 as uuidv4 } from 'uuid';
export function generateUuid() {
    return uuidv4();
}
export function isUUID(input) {
    const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
    return regex.test(input);
}
